export enum WageAndTravelReimbursementRequestStatus {
    PendingFix = 0,
    PendingApproval = 1,

    AutoApproved = 10, 
    CenterApproved = 11,
    AdminApproved = 12,

    CenterDeclined = 20,
    AdminDeclined = 21,

    Reimbursed = 100
}